import { createContext, useContext } from "react";
import {
  GET_COMPARE_LIST,
  GET_COMPARE_LIST_AFTER_SIGNIN,
} from "../Pregrine/ComparePage/comparePage.gql";
import { useLazyQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const CompareContext = createContext();

export const CompareProvider = ({ children }) => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const { compareListId } = useSelector((state) => state.compareListSlice);
  const [data, setData] = useState(null);

  // Without Signin
  const [
    getCompareList,
    { data: compareListData, loading: compareListLoading },
  ] = useLazyQuery(GET_COMPARE_LIST, {
    variables: {
      compareListId,
    },
    fetchPolicy: "cache-and-network",
    skip: !compareListId || isSignedIn,
  });

  // With Signin
  const [
    getCompareListAfterSignin,
    { data: compareDataOnSignin, loading: compareLoadingOnSignin },
  ] = useLazyQuery(GET_COMPARE_LIST_AFTER_SIGNIN, {
    fetchPolicy: "cache-and-network",
    skip: !isSignedIn,
  });

  useEffect(() => {
    if (isSignedIn) {
      getCompareListAfterSignin();
    } else {
      getCompareList();
    }
  }, [isSignedIn, compareListId]);

  function setDataBasedOnSignedIn(isSignedIn) {
    if (!isSignedIn) {
      if (
        compareListData &&
        compareListData.compareList &&
        compareListData.compareList &&
        compareListData.compareList.items
      ) {
        setData(compareListData.compareList.items);
      }
    } else {
      if (
        compareDataOnSignin &&
        compareDataOnSignin.customer &&
        compareDataOnSignin.customer.compare_list &&
        compareDataOnSignin.customer.compare_list.items
      ) {
        setData(compareDataOnSignin.customer.compare_list.items);
      }
    }
  }

  useEffect(() => {
    setDataBasedOnSignedIn(isSignedIn);
  }, [compareListLoading, compareLoadingOnSignin]);

  return (
    <CompareContext.Provider
      value={{
        data,
        loading: compareListLoading || compareLoadingOnSignin,
        getCompareList,
        getCompareListAfterSignin,
        setData,
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  return useContext(CompareContext);
};
